<script>
import MultiSelect from 'primevue/multiselect';


export default {
    components: { MultiSelect },
    props: ['field', 'value', 'disabled', 'api', 'format', 'sortField', 'name', 'localized', 'changeFn', 'disableStore', 'staticOptions'],
    data(){
        return {
           
        }
    },
    mounted(){
        this.loadOptions();
    },
    computed: {
        options(){
            let store = this.disableStore ? this.staticOptions : this.$store.state.masterData[this.name];
            return store;
        }
    },
    methods: {
        loadOptions(){
            if(!this.options){
                let params = {}
                if(this.sortField){
                    params = {
                        sort: JSON.stringify([{property: this.sortField, direction: 'asc'}])
                    };
                }

                let payload = {
                    params: params,
                    name: this.name,
                    api: this.api
                };
                this.$store.dispatch("masterData/loadData", payload);
            }
        },
        onChange(e){
            if(this.changeFn){
                let p = this.options.filter((el) => {
                    return el.value == e.value;
                });
                this.changeFn(p[0])
            }

        }
    }
}


</script>


<template>
    <MultiSelect :options="options" optionLabel="label" optionValue="value" display="chip" :disabled="this.disabled" :showClear="true">
        <template #value="slotProps">
            <div v-for="option of slotProps.label" :key="option">
                <span>{{localized ? $t(option) : option}}</span>
            </div>
        </template>
        <template #option="slotProps">
            <div>
                <span>{{$t(slotProps.option.label)}}</span>
            </div>
        </template>
    </MultiSelect>
</template>